import { CartographyResourceInfos } from '../cartography-resource-infos';

export abstract class CartographyInfosResourcePosition extends CartographyResourceInfos {
  public latitude: number;
  public longitude: number;
  public date: Date;
  public hour: string;
  public address: string;

  constructor(idResource: string) {
    super(idResource);
  }
}
